import {
  GET_BENEFACTORS,
  BENEFACTORS,
  BENEFACTOR_ERROR,
  BENEFACTOR_SUCCESS,
  CREATE_BENEFACTOR,
  GET_MY_BENEFACTORS,
  MY_BENEFACTORS,
} from '../actions';

const INIT_STATE = {
  total_benefactors: [],
  my_benefactors: [],
  loading: false,
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BENEFACTORS:
    case GET_MY_BENEFACTORS:
    case CREATE_BENEFACTOR:
      return {
        ...state,
        loading: true,
        error: '',
        success: '',
      };
    case MY_BENEFACTORS:
      return {
        ...state,
        my_benefactors: action.payload.benefactors,
      };
    case BENEFACTORS:
      return {
        ...state,
        total_benefactors: action.payload.benefactors,
      };
    case BENEFACTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: action.payload.message,
      };
    case BENEFACTOR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    default:
      return { ...state };
  }
};
